import script from "./ReceivingRecordIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReceivingRecordIndex.vue?vue&type=script&setup=true&lang=ts"

import "./ReceivingRecordIndex.vue?vue&type=style&index=0&id=1f9970c0&lang=scss&scoped=true"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f9970c0"]])

export default __exports__